export const ORGANISATIONS_GROUP_ROUTES = {
  BASE: "/organisations/*",
  LIST: "/",
};

export const ORGANISATIONS_GROUP_LINKS = {
  BASE: "/app/organisations",
  LIST: "/app/organisations",
};